import { app } from '../../../app';
import { Controller } from './google-marketplace-instructions.controller';

app.component('companyGoogleMarketplaceInstructions', {
    bindings: {
      appType$: '<',
      companyId: '<'
    },
    controller: Controller,
    templateUrl: require('./google-marketplace-instructions.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/google-marketplace-instructions/google-marketplace-instructions.component.js